<template>
  <modal @cancel="cancel" class="option">
    <header class="header mui-bar-nav mui-bar" slot="header">
      <span @click="cancel" class="system-icon-close"></span>
      审批{{state===1?"同意":"拒绝"}}意见
    </header>
    <div class="content" slot="content">
      <textarea autofocus="autofocus" placeholder="请输入审批意见"  v-model="opinion"></textarea>

    </div>
    <div slot="footer" class="footer">
      <div  class="layout">
        <div @click="cancel" class="modal-button">取消</div>
        <div @click="confirm" class="modal-button active">确定</div>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from "@maidi/common";

export default {
  name: "opinion",
  components: { Modal },
  props: ["state"],
  data() {
    return { opinion: ""};
  },
  methods: {
    async confirm() {
      this.$emit("confirm", {
        opinion: this.opinion
      });
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  mounted() {
    this.$el.querySelector("textarea").focus();
    setTimeout(() => {
      this.$el.querySelector("textarea").focus();
    }, 200);
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/global";

.switch-mobile {
  .option {
    /deep/ .modal {
      display: flex;
      flex-direction: column;
      .modal-content {
        flex: 1 1 0;
        display:flex;
      }
    }
  }

  .footer-btn {
    margin: 10px 0;
    height: 40px;
    border-radius: 7px;
    line-height: 29px;
  }

  .content {
    margin-top: 70px;
    padding: 0;
    width: 100%;
    display: flex;
    textarea {
      flex: 1;
      height:auto;
      margin-bottom:0;
    }
  }

  .header .system-icon-close {
    float: right;
    padding: 0 10px;
  }
}

.header {
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  .system-icon-close {
    display: none;
  }
}

.content {
  width: 700px;
  padding: 5px 15px;
  textarea {
    resize: none;
    border-radius: 2px;
    height: 200px;
    width: 100%;
    max-width: 100%;
    outline: none;
    padding: 10px;
    border: 1px solid $color-bg-active;
  }
}

.footer {
  padding: 5px 15px 5px;
}
</style>
